import DiaVariants from "./GenomicsAux/DiaVariants";
import ToArchive from "./GenomicsAux/ToArchive";
import DiaVarPathogenic from "./GenomicsAux/DiaVarPathogenic";
import MainImageCardDashboard2 from "../../../components/Cards/MainImageCardDashboard2";
import HeaderCardSmall from "../../../components/Header/HeaderCardSmall";
//import DiaIGVbright from "../../../components/IGV/DiaIGVbright"
import { dna6 } from "../../../constants";


export default function GenomicsCard() {

return (
<>

    <MainImageCardDashboard2

        content = {<HeaderCardSmall cardheadline={'Genomics 360'} /> }

        iconbuttons = {<>               
                     <DiaVarPathogenic />
                    
                     <DiaVariants />
                     <ToArchive />            
                 </>}  

        photo = { dna6 }  

    />

</>
)};
